module.exports = __webpack_public_path__ + "img/errors_list.9a228fda.svg";